import React from 'react';
import { Col, Row, Modal, Input, Button } from 'antd';
import './index.css';

const CollectionBox = (props) => {
    const {
        titleIntroduction,
        title,
        contentIntroduction,
        visible,
        onOk,
        onCancel,
        modalTitle,
        addTagInputValue,
        addTagInputValueChangeHandler,
    } = props;
    return (
        <Modal
            visible={visible}
            // onOk={onOk}
            onCancel={onCancel}
            title={modalTitle}
            // cancelText={'放弃并清空数据'}
            // okText={tagOrSynonym ? '请再三确认再提交': '查看有没有重复标签'}
            footer={<Button type={'primary'} onClick={onOk}>确认</Button>}
        >
            <div className={"collections-box"}>
                <div className={"collection-box-content"}>
                    <Row
                        style={{
                            marginTop: 30,
                        }}
                    >
                        <Col
                            span={8}
                            style={{
                                textAlign: "center"
                            }}
                        >
                            <span>
                                {titleIntroduction}：
                            </span>
                        </Col>
                        <Col span={16}>
                        <h3
                            style={{
                                textAlign: "center"
                            }}
                        >
                            {
                                title
                            }
                        </h3>
                        </Col>
                    </Row>
                    <Row
                        style={{
                            marginTop: 30,
                        }}
                    >
                        <Col span={8}>
                            <div
                                className={"collection-box-introduction"}
                                style={{
                                    textAlign: "left",
                                }}
                            >
                                {
                                    contentIntroduction
                                }
                            </div>
                        </Col>
                        <Col span={16}>
                            <div className={"collection-box-main"}>
                                <Input.TextArea
                                    placeholder={"请输入新标签"}
                                    value={addTagInputValue}
                                    onChange={addTagInputValueChangeHandler}
                                    style={{
                                        resize: 'none',
                                        height: '100%'
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </Modal>
    )
}

export default CollectionBox;